/**
 * Brewie FAQ Cards — animated <details>
 *
 * <details> has no native open/close transition, so this drives the height with
 * the Web Animations API while leaving the element's semantics intact.
 *
 * Without JS the section still works: <details> opens instantly and the `name`
 * attribute handles one-at-a-time natively. When JS runs we take over both, so
 * closing a sibling animates instead of snapping shut.
 */

(function () {
  'use strict';

  if (window.__brewieFaqInit) return;
  window.__brewieFaqInit = true;

  var animations = new WeakMap();

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function measureOpenHeight(item) {
    var previous = item.style.height;
    item.style.height = 'auto';
    var height = item.getBoundingClientRect().height;
    item.style.height = previous;
    return height;
  }

  function cancelExisting(item) {
    var existing = animations.get(item);
    if (existing) {
      existing.cancel();
      animations.delete(item);
    }
  }

  function settle(item) {
    item.style.height = '';
    item.style.overflow = '';
    animations.delete(item);
  }

  function duration(list) {
    var ms = parseInt(list.getAttribute('data-faq-duration'), 10);
    return isNaN(ms) ? 260 : ms;
  }

  function open(item, list) {
    cancelExisting(item);
    var startHeight = item.getBoundingClientRect().height;

    item.open = true;
    var endHeight = measureOpenHeight(item);

    item.style.overflow = 'hidden';
    var animation = item.animate(
      { height: [startHeight + 'px', endHeight + 'px'] },
      { duration: duration(list), easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
    );
    animations.set(item, animation);
    animation.onfinish = function () { settle(item); };
    animation.oncancel = function () { settle(item); };
  }

  function close(item, list) {
    cancelExisting(item);
    var startHeight = item.getBoundingClientRect().height;
    var summary = item.querySelector('summary');
    var styles = window.getComputedStyle(item);
    var endHeight =
      summary.getBoundingClientRect().height +
      parseFloat(styles.borderTopWidth || 0) +
      parseFloat(styles.borderBottomWidth || 0);

    item.style.overflow = 'hidden';
    var animation = item.animate(
      { height: [startHeight + 'px', endHeight + 'px'] },
      { duration: duration(list), easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
    );
    animations.set(item, animation);
    animation.onfinish = function () {
      item.open = false;
      settle(item);
    };
    animation.oncancel = function () { settle(item); };
  }

  function init(list) {
    if (list.dataset.faqReady === 'true') return;
    list.dataset.faqReady = 'true';

    // We manage exclusivity ourselves so the outgoing panel can animate shut.
    // The attribute stays in the markup as the no-JS fallback.
    list.querySelectorAll('details[name]').forEach(function (item) {
      item.dataset.faqExclusive = 'true';
      item.removeAttribute('name');
    });
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('summary');
    if (!summary) return;

    var item = summary.parentElement;
    if (!item || item.tagName !== 'DETAILS') return;

    var list = item.closest('[data-faq-animate]');
    if (!list) return;

    init(list);

    if (prefersReducedMotion()) return;

    event.preventDefault();

    if (item.open) {
      close(item, list);
      return;
    }

    if (item.dataset.faqExclusive === 'true') {
      list.querySelectorAll('details[open]').forEach(function (sibling) {
        if (sibling !== item) close(sibling, list);
      });
    }

    open(item, list);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-faq-animate]').forEach(init);
  });

  // Theme editor re-renders the section without a fresh page load.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-faq-animate]').forEach(init);
  });
})();
